import { h, render, Component } from 'preact';
import { makeid } from '../utils/utils';

class TxrInput extends Component {
    state = {
        isMobileMenuOpened: false,
        isScrolled: false
    }
    
    getFirstError = ()  => {
        let errors = Object.entries(this.props.model.errors);
        let firstError = '';
        for (const [key, value] of errors) {
            if(!!value) {
             firstError = this.props.errors[key];
             this.hasError = true;
             return firstError;
            }
        }
        this.hasError = false;
        return '';
     }
     txrEdit = (e) => {
        this.props.model.touched = true;
        this.props.model.value = e.target.value;
        if(this.props.model.change) {
            this.props.model.change(this.props.model);
        }
    }
   txrEditChange = (e) => {
        this.props.model.touched = true;
        this.props.model.value = e.target.value;
        if(this.props.model.change) {
            this.props.model.change(this.props.model);
        }
    }

    txrOnBlur = (e) => {
        if(this.props.model.onBlur) {
            this.props.model.onBlur(this.props.model);
        }
    }
    componentDidMount = () => {
        const id = (this.props.name ? this.props.name: '') + makeid(10);
       this.setState({id: id});
    }

    render() {
        const floatPlaceholder = !!this.props.floatingPlaceholder;
        return (
            <div class={'txr-input' + (this.props.model.invalid ? ' invalid' : '') + (this.props.model.value || this.props.existvalue ? ' has-value' : '') + (floatPlaceholder ? ' txr-input--floating-placeholder' : '')}>
                <div class="txr-input__container">
                    <input id={this.state.id} onKeyup={(e) => this.txrEdit(e)} onChange={(e) => this.txrEditChange(e)} class="txr-input__input" type={this.props.type ? this.props.type : 'text'} 
                    autocomplete={this.props.autocomplete ? this.props.autocomplete: '' } name={this.props.name ? this.props.name: '' } placeholder={this.props.placeholder != null ? this.props.placeholder : ''}  value={this.props.model.value} onBlur={(e) => this.txrOnBlur(e)}/>  
                    <label class="txr-input__label" for={this.state.id }>{this.props.label}</label>
                    { this.props.rightSlot &&
                        <div class="txr-input__right-slot">
                            {this.props.rightSlot}
                        </div>
                    }
                    { this.props.loading &&
                        <div class="txr-input__right-slot">
                            <i class="txr-button__spin-icon fas fa-circle-notch fa-spin"></i>
                        </div>
                    }


                </div>
                { this.props.errors &&
                    <div class="txr-input__errors">
                        {this.getFirstError()}
                    </div>
                }
                { this.props.bottomSlot &&
                 <div class="txr-input__bottom-slot">{this.props.bottomSlot}</div>
                }

            </div>
        )
    }
}

export default TxrInput;